import React from 'react'

const Footer = () => {
    
   
    return (
        <>
            <footer>
            <div className="inner_wrap wow fadeInUp">
                <a href="https://game.longeplay.com.tw/service_quick/question?site=h55naxx2tw" title="客服問題回報" target="_blank" rel="noreferrer" className="service_link">
                    <img src="/events/img/footer_01.jpg" alt="網易遊戲 龍邑遊戲" />
                </a>
                <img src="/events/img/footer_02.png" alt="" />
            </div>
        </footer>
        
        </>
    )
}

export default Footer
